import { render, staticRenderFns } from "./PillsErrorPage.vue?vue&type=template&id=4bba4b64&"
import script from "./PillsErrorPage.vue?vue&type=script&lang=js&"
export * from "./PillsErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports